import { format } from 'date-fns';

import { DATE_FORMATS } from './constants';
import { type DateDisplayProps } from './types';

const DateDisplay = ({
  date,
  emptyValue = '-',
  fallbackValue = '-',
  format: formatString = 'shortDateTime',
}: DateDisplayProps) => {
  if (date === '' || date === null || date === undefined) return emptyValue;

  try {
    return format(date, DATE_FORMATS[formatString]);
  } catch (e) {
    console.error(e);

    return fallbackValue;
  }
};

export { DateDisplay };
